(function () {
	'use strict';

	angular
		.module('app.setup')
		.controller('manageCacheCtrl', manageCacheCtrl);

	function manageCacheCtrl($rootScope, $scope, $timeout, manageCacheService) {
		$scope.factoryNdxs = '';
		$scope.cacheObjectTypes = '';

		$scope.submitForm = submitForm;
		$scope.clearForm = clearForm;

		function submitForm() {
			// default to all if blank
			var cacheObjectTypes = $scope.cacheObjectTypes || 'fullfactory';
			manageCacheService.refreshCache($scope.factoryNdxs, cacheObjectTypes)
				.then(function(response) {
					if (response.status) {
						if (response.status === 200) {
							$rootScope.$emit('toast', {
								'message': 'Refresh request successful'
							});
						} else if (response.status >= 400) {
							$rootScope.$emit('toast', {
								'message': 'Refresh request failed',
								'success': false
							});
						}
					}
				});
		}

		function clearForm() {
			$scope.factoryNdxs = '';
			$scope.cacheObjectTypes = '';
		}
	}
})();
